<div class="card">
    <div class="card-header p-1">
        <div class="text-center py-1" style="margin-left:25%;vertical-align: middle; ">
            {{dateyear}} <img src="../../../assets/img/footer-logo 1.png" height="20" />
        </div>
    </div>
</div>